import {Injectable} from '@angular/core';
import {Http, ResponseContentType, URLSearchParams} from '@angular/http';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import {App} from 'ionic-angular';
import {OauthService} from './oauth.service';
import {Search} from '../models/search/search.model';
import {Observable} from 'rxjs/Observable';
import {CartInterface} from '../models/cart/cart.interface';
import {ToolsService} from './tools.service';
import { HttpResponse } from '@angular/common/http';
declare var device: any;
import { ResponseMessage } from '../models/responseMessage/responseMessage.model';
import {AppProvider} from "../../core/app/app-provider.service";

@Injectable()
export class OrderService extends OauthService {

  public loader = new Subject<boolean>();

  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService,
  ) {
    super(http, app, appProvider, tools);

    this.loader.next(true); // init custom loader
  }

  getAllOrder(idBenef: string) {
    const url = this.Routing.generate('api_get_commandes', {'_format': 'json'}, true);
    const params = new URLSearchParams();

    params.set('beneficiaire', idBenef.toString());

    return this.http
      .get(url, {search: params, headers: this.updateHeaders()})
      .map(response => {
        return response.json().data;
      });
  }

  getOrder(idOrder) {
    const url = this.Routing.generate('api_get_commande', {'_format': 'json', 'commande': idOrder}, true);

    return this.http
      // .get(`${url}/${idOrder}`, {headers: this.updateHeaders()})
      .get(`${url}`, {headers: this.updateHeaders()})
      .map(response => {
        this.loader.next(false); // enable custom loader
        return response.json().data;
      });
  }

  getBilletsList(orderId: Number) {
    const param = {'_format': 'json'};
    param['commande'] = orderId;
    const url = this.Routing.generate('api_get_commande_reducce_billet_list', param, true);

    return this.http
      .get(`${url}`, {headers: this.updateHeaders()})
      .map(response => {
        this.loader.next(false); // enable custom loader
        return response.json().data;
      });
  }

  getBilletFileUrl(orderId: Number, index: Number) {
    const param = {'_format': 'json'};
    param['commande'] = orderId;
    param['billet'] = index;
    param['access_token'] = this.tools.localStorageService.getOauthToken();
    param['codeCe'] = this.tools.localStorageService.getCe().code;

    return this.Routing.generate('api_get_commande_reducce_billet', param, true);
  }

  checkoutCartDelivery(cart, lignes) {
    const param = {'_format': 'json'};
    param['cart'] = cart;

    const url = this.Routing.generate('api_post_checkout_livraison', param, true);

    return this.http
      .post(url, lignes, {headers: this.updateHeaders()})
      .map(response => {
        return response.json();
      });

    // api_post_checkout_livraison
    /*
    const url = `${this.Routing.context_.scheme}://${this.Routing.context_.host}/api/checkout`;

    return this.http
      .post(`${url}/${cart}/livraison.json`, lignes, {headers: this.updateHeaders()})
      .map(response => response.json());

     */
  }

  updateStatus(status) {
    const url = this.Routing.generate('api_put_commande_status_update', {'_format': 'json'}, true);

    return this.http
      .put(url, JSON.stringify(status), {headers: this.updateHeaders()})
      .map(response => response.json());
  }

  validateCart(idOrder) {
    const url = this.Routing.generate('api_post_commande_validation', {'_format': 'json', 'commande': idOrder}, true);

    return this.http
      .post(`${url}`, JSON.stringify({facturer: 1}), {headers: this.updateHeaders('beneficiaire')})
      .map(response => response.json());
  }

  invoiceCart(idOrder) {
    const url = this.Routing.generate('api_post_commande_facturation', {'_format': 'json', 'commande': idOrder}, true);

    return this.http
      .post(`${url}`, JSON.stringify({}), {headers: this.updateHeaders('beneficiaire')})
      .map(response => response.json());
  }

  getAllOrderHistory(search: Observable<Search> = null) {
    return search.debounceTime(500)
      .distinctUntilChanged()
      .switchMap(s => this.searchAllOrderHistory(s, s.action));
  }

  searchAllOrderHistory(search: Search, action: string) {
    const param = {'_format': 'json'};

    for (const item in search) {
      if (search[item]) {
        param[item] = search[item];
      }
    }

    const url = this.Routing.generate('api_get_commandes_historique', param, true);

    return this.http
      .get(url, {headers: this.updateHeaders()})
      .map(response => {
        this.loader.next(false); // disable custom loader
        return {data: response.json().data, action};
      });
  }

  predateCart(cart, date) {
    const param = {'_format': 'json'};
    param['commande'] = cart;

    const url = this.Routing.generate('api_patch_commande', param, true);

    return this.http
      .patch(url, JSON.stringify({date: date}), {headers: this.updateHeaders()})
      .map(response => response.json());
  }

  /**
   * @param {CartInterface} cart
   * @param {Array<any>} value
   * @returns {Observable<CartInterface>}
   */
  partialUpdate(cart: CartInterface, value: Array<any>): Observable<CartInterface> {
    const param = {
      _format: 'json',
      commande: cart.id
    };

    const url = this.Routing.generate('api_patch_commande', param, true);

    return this.http
      .patch(url, JSON.stringify(value), {headers: this.updateHeaders()})
      .map(response => response.json());
  }

  cancelOrder(idOrder) {
    const url = this.Routing.generate('api_post_commande_cancel', {'_format': 'json', 'commande': idOrder}, true);

    return this.http
      .post(`${url}`, JSON.stringify({}), {headers: this.updateHeaders()})
      .map(response => response.json());
  }

  public deleteOrder(cart): Observable<ResponseMessage> {
    const url = this.Routing.generate('api_delete_commande', {'_format': 'json', 'commande': cart}, true);

    return this.http
      // .delete(`${url}/${cart}`, {headers: this.updateHeaders('beneficiaire')})
      .delete(`${url}`, {headers: this.updateHeaders('beneficiaire')})
      .map(response => {
        return response.json();
      });
  }

  public sendOrderCancellationRequest(orderId: number, comment: string): Observable<ResponseMessage> {
    const url = this.Routing.generate('api_post_commande_send_order_cancellation_request', {
      '_format': 'json',
      'commandeId': orderId
    }, true);

    return this.http
      .post(`${url}`, JSON.stringify({commentaire: comment}), {headers: this.updateHeaders()})
      .map(response => response.json());
  }

  public cancelOrderById(orderId: number): Observable<ResponseMessage> {
    const url = this.Routing.generate('api_post_commande_cancel_order', {
      '_format': 'json',
      'commandeId': orderId
    }, true);

    return this.http
      .post(`${url}`, {}, {headers: this.updateHeaders()})
      .map(response => response.json());
  }

  public getDetailMvt(commandeId: Number) {
    const param = {'_format': 'json'};
    param['commande'] = commandeId;
    const url = this.Routing.generate('api_get_commande_detail_mvt', param, true);

    return this.http
      .get(`${url}`, {headers: this.updateHeaders()})
      .map(response => {
        this.loader.next(false); // enable custom loader
        return response.json().data;
      });
  }

}



// WEBPACK FOOTER //
// ./src/shared/services/order.service.ts